// Ротационные пулы фраз — spec/08_copy.md. Выбор конкретной фразы делает `pickRotating`
// (или `pickRotatingStable` для стабильного выбора без прыжков при ререндере).
//
// Ответы на отметку — вариант A «своя в чате» (docs/copy-variants.md), кроме ветки `hard`:
// там ирония выключена полностью (CLAUDE.md правило 19). Комплименты не тронуты: это тексты
// лучика, они везде звучат ясно и тепло, без мема (выбор основателя).
import { textByGender } from '@lunya/contracts'

import type { ComplimentCopy, MoodReplyCopy, VerdictCopy } from './types'

/**
 * Ответ Луни на отметку состояния. Обязателен при 0 связей и при «Тяжко».
 * Ветка `hard` — без советов и драматизации (тревожный сценарий, ирония выключена).
 *
 * Пул — функция от пола пользователя: фраза «сиять каждый день не обязана» была женской
 * для всех. Остальные ветки пола не требуют, но форму держат одинаковую — иначе на вызывающей
 * стороне пришлось бы помнить, какая ветка функция, а какая массив.
 */
export const moodReply: MoodReplyCopy = {
  shine: () => ['Сияешь? Записала. Люблю такие дни.', 'Вот с таким лицом и ходи, идёт тебе.'],
  ok: () => ['Норм — тоже день. Засчитано.', 'Ровно так ровно. Я рядом.'],
  meh: ({ gender }) => [
    'Так себе — тоже честно. Хвост на твоей стороне.',
    textByGender(
      gender,
      'Бывает. Сиять каждый день не {обязан|обязана}.',
      'Бывает. Сиять каждый день никто не должен.',
    ),
  ],
  hard: () => [
    'Поняла. Обняла хвостом. Близкие увидят.',
    'Тяжко — это не навсегда. Я посижу рядом.',
    'Ничего не буду советовать. Просто побуду тут.',
  ],
}

/**
 * Готовые комплименты — ОДИН набор на все типы связи (правка основателя).
 *
 * Источник правды — бэкенд (`apps/api/src/content/complimentPool.ts`), тут копия для моков
 * и для проверок копирайта. Раньше пулов было три (подруга / мама / половинка), и остальные
 * типы переиспользовали ближайший по тону; разделение не окупалось, а своё человек всё равно
 * может написать.
 */
export const compliment: ComplimentCopy = [
  'Люблю тебя',
  'Ты моя вкусняшка',
  'Не грусти, я рядом',
  'Ты со всем справишься',
  'Скучаю по тебе',
]

/** Строки-приговоры совместимости — курируемый пул, по диапазонам процента. */
// Копия боевого пула из `apps/api/src/content/verdictPool.ts` — её читают ТОЛЬКО моки
// (`compat/api/mockData/scoring.ts`), в проде приговор приезжает с бэкенда вместе с
// проверкой. Две копии обязаны совпадать дословно, иначе локальная разработка показывает
// не то, что увидит человек: на момент этой правки они уже разошлись на три строки из
// четырёх, и заметить это было нечем.
export const verdict: VerdictCopy = {
  '90+': ['Это уже неприлично хорошо. Даже я завидую.'],
  '70-89': ['Такое сочетание берегут. Правда.'],
  '50-69': ['Работает, если оба стараются. А вообще вы милашки!'],
  '35-49': ['Сложная пара. Но сложные пары — самые интересные.'],
  '30-34': ['Совсем вы разные. Это не приговор, просто лёгким тут ничего не будет.'],
}
